import React from 'react';
import {FormLabel} from '@chakra-ui/react';

export const ConfigFormLabel = ({children}: {children: React.ReactNode}) => {
  return (
    <FormLabel fontSize="xs" textTransform="uppercase">
      {children}
    </FormLabel>
  );
};
